import type { definitions } from '@luxuryescapes/contract-trip'
import { stageChatPrompt, consumeStagedChatPrompt } from './stagedChatPrompt'

export const CLASSIC_TRIP_MIGRATION_SCHEMA_VERSION = 'classic-trip-to-chat-v1'
export const CLASSIC_TRIP_MIGRATION_QUERY_PARAM = 'classicTripMigration'
export const CLASSIC_TRIP_MIGRATION_PROMPT_PREFIX = 'Please migrate this classic Trip Planner itinerary into AI TripPlanner.'

const CLASSIC_TRIP_MIGRATION_PROMPT_STORAGE_PREFIX = 'tripPlanner:classicTripMigrationPrompt:'

export type ClassicTripMigrationPayload = definitions['classicTripMigrationPayload']

// Keep the established query/storage namespace so tokens from existing tabs
// remain consumable after rollout, while sharing the single-use storage logic.
export function stageClassicTripMigrationPrompt(prompt: string): string {
  return stageChatPrompt(prompt, CLASSIC_TRIP_MIGRATION_PROMPT_STORAGE_PREFIX).token
}

export function consumeClassicTripMigrationPrompt(token: string | null | undefined): string | undefined {
  return consumeStagedChatPrompt(token, CLASSIC_TRIP_MIGRATION_PROMPT_STORAGE_PREFIX)
}

export function buildClassicTripMigrationPromptFromPayload(payload: ClassicTripMigrationPayload): string {
  return [
    CLASSIC_TRIP_MIGRATION_PROMPT_PREFIX,
    'Create a new chat trip plan that preserves the itinerary structure, dates, places, notes, booked status, and Luxury Escapes offer references.',
    'Use place names and regions as location context. Do not invent missing place details unless the structured place data is incomplete.',
    '',
    '```json',
    JSON.stringify(payload, null, 2),
    '```',
  ].join('\n')
}
